export const getClient = () => {
  // Check URL params first
  const params = new URLSearchParams(window.location.search);
  const clientFromParam = params.get("client");
  if (clientFromParam) return clientFromParam.toLowerCase();

  const subdomain = window.location.hostname.split(".")[0];
  if (subdomain && subdomain !== "www") return subdomain.toLowerCase();

  return "default"; // Fallback if no client is found
};
